// Centralized site content for Gateway Boat Co.
// Edit copy, vessels, rivers, and partners here.

export const COMPANY = {
  name: "Gateway Boat Co.",
  shortMark: "GBC",
  tagline: "Vessels for independent river days across Southwest Montana.",
  location: "Bozeman, MT",
  phone: "406-804-9176",
  phoneHref: "tel:+14068049176",
  email: "info@gatewayboatco.com",
  emailHref: "mailto:info@gatewayboatco.com",
  reviewUrl: "https://www.google.com/maps",
  instagramUrl: "https://www.instagram.com/",
  facebookUrl: "https://www.facebook.com/",
  paddle: "/brand/paddle.png",
  paddleX: "/brand/paddles-x.png",
  logoFull: "/brand/gbc-logo-full.png",
  logo: "/brand/gbc-logo-full.png",
};

export const NAV = [
  { to: "/fleet", label: "The Fleet" },
  { to: "/home-waters", label: "Our Home Waters" },
  { to: "/conservation", label: "Conservation & Community" },
  { to: "/planning-tools", label: "Planning Tools" },
];

export const HERO = {
  image: "https://images.unsplash.com/photo-1671391511358-226c1799e054?auto=format&fit=crop&w=2400&q=80",
  imageAlt: "A quiet Southwest Montana river at first light",
  headline: "Gateway Boat Co.",
  line: "Vessels for independent river days across Southwest Montana.",
};

export const PAGE_HEROES = {
  fleet: {
    image: "https://images.pexels.com/photos/27430406/pexels-photo-27430406.jpeg?auto=compress&cs=tinysrgb&w=2400",
    title: "The Fleet",
    subtitle: "Vessels for self-guided river days.",
  },
  homeWaters: {
    image: "https://images.unsplash.com/photo-1505852959938-8193566b2f8e?auto=format&fit=crop&w=2400&q=80",
    title: "Our Home Waters",
    subtitle: "Plan the day with current flows, weather, and river resources.",
  },
  conservation: {
    image: "https://images.unsplash.com/photo-1604087472033-cae0bd418fec?auto=format&fit=crop&w=2400&q=80",
    title: "Conservation & Community",
    subtitle: "",
  },
  planning: {
    image: "https://images.unsplash.com/photo-1634829983497-05683868a580?auto=format&fit=crop&w=2400&q=80",
    title: "Planning Tools",
    subtitle: "Useful. Calm. Practical.",
  },
  faq: {
    image: "https://images.unsplash.com/photo-1579539771986-d715a566e4fb?auto=format&fit=crop&w=2400&q=80",
    title: "FAQ",
    subtitle: "Practical answers.",
  },
  book: {
    image: "https://images.unsplash.com/photo-1551942296-97384c850440?auto=format&fit=crop&w=2400&q=80",
    title: "Book Now",
    subtitle: "Reserve your river day.",
  },
  contact: {
    image: "https://images.unsplash.com/photo-1685550903259-96799741df9e?auto=format&fit=crop&w=2400&q=80",
    title: "Contact",
    subtitle: "Direct, simple, no filler.",
  },
};

export const COMMITMENTS = {
  primary: {
    title: "Montana DNA",
    body: "Strong connections to the place behind the day.",
  },
  secondary: [
    {
      title: "River Independence",
      body: "Self-guided days. Your river, your pace, your way.",
    },
    {
      title: "4 the Water",
      body: "A portion of every booking goes back to our home waters.",
    },
  ],
};

export const VESSELS = [
  {
    slug: "big-eddy-360",
    name: "Clackacraft Big Eddy 360",
    shortName: "Clackacraft Big Eddy 360",
    line: "High-sided classic McKenzie-style drift boat.",
    rate: "$225 / 24 hours",
    rateValue: "$225",
    image: "https://images.pexels.com/photos/27430406/pexels-photo-27430406.jpeg?auto=compress&cs=tinysrgb&w=2000",
    specs: [
      { label: "Centerline", value: "16'6\"" },
      { label: "Beam", value: "82\"" },
      { label: "Side height", value: "24\"" },
      { label: "Weight", value: "Approx. 285 lbs" },
    ],
    description:
      "Classic McKenzie-style drift boat. Stable and spacious with higher sides for peace of mind on bigger water. Rows light, holds well, and tracks straight even loaded. Seats up to three plus a rower.",
    requirements: [
      "FishCamp drift boat clinic required before reservation.",
      "Rowing experience required.",
    ],
    notes: "Final anchor setup and Yeti seating to be confirmed before publishing.",
    intent: "stable, capable, classic",
  },
  {
    slug: "sotar-westslope",
    name: "Sotar Westslope",
    shortName: "Sotar Westslope",
    line: "Versatile raft and frame setup for fishing or recreational floats.",
    rate: "$225 / 24 hours",
    rateValue: "$225",
    image: "https://images.unsplash.com/photo-1551942296-97384c850440?auto=format&fit=crop&w=2000&q=80",
    specs: [
      { label: "Length", value: "13'6\"" },
      { label: "Inside width", value: "36\"" },
      { label: "Tube diameter", value: "20\" to 15\"" },
      { label: "Air chambers", value: "4 + floor" },
    ],
    description:
      "Light and agile raft and frame setup. Fish it with angling seats, load the front bench for a scenic float, or rig it with thwarts and paddles for a full recreational day on the river. Plenty of room for gear, coolers, and passengers.",
    requirements: [],
    notes: "Final custom dimensions to be confirmed before publishing.",
    intent: "versatile without being busy",
  },
  {
    slug: "watermaster-bruin",
    name: "WaterMaster Bruin",
    shortName: "WaterMaster Bruin",
    line: "Portable framed raft with flexible transport options.",
    rate: "$175 / 24 hours",
    rateValue: "$175",
    image: "https://images.unsplash.com/photo-1629248457649-b082812aea6c?auto=format&fit=crop&w=2000&q=80",
    specs: [
      { label: "Length", value: "11.5'" },
      { label: "Width", value: "5'" },
      { label: "Raft weight", value: "59 lbs" },
      { label: "Capacity", value: "1,500 lbs" },
    ],
    description:
      "The Bruin is the convenience craft: truck-bed ready, roof-rack ready when properly secured, or broken down and packed when the day calls for it. It gives a framed raft option without committing the whole day to trailer logistics. Use it for smaller water, skinny channels, quick access, or days when portability matters as much as river capability.",
    requirements: [],
    notes: "Trailer option available — trailer-supported Bruin rentals priced at $225 / 24 hours.",
    trailerOption: "Trailer option available: $225 / 24 hours",
    intent: "practical, versatile, portable",
  },
  {
    slug: "watermaster-kodiaks",
    name: "Pair of WaterMaster Kodiaks",
    shortName: "Pair of WaterMaster Kodiaks",
    line: "Packable one-person rafts for simple access and easy transport.",
    rate: "$75 each / 24 hours",
    rateValue: "$75",
    rateSuffix: "each",
    image: "https://images.unsplash.com/photo-1685550903259-96799741df9e?auto=format&fit=crop&w=2000&q=80",
    specs: [
      { label: "Overall length", value: "8'10\"" },
      { label: "Overall width", value: "4'4\"" },
      { label: "Raft weight", value: "27 lbs" },
      { label: "Package weight", value: "42 lbs" },
    ],
    description:
      "One-person WaterMaster rafts built for convenience and access. They pack small, launch easily, and do not need a trailer. Row them with oars, move hands-free with fins, or use them as a stable personal craft for quiet water, smaller channels, lakes, and days when simple logistics matter. Available with or without a floor.",
    requirements: [],
    notes: "Final Kodiaks description to be confirmed before publishing.",
    intent: "simple, light, portable, useful",
  },
];

export const GEAR_AND_DELIVERY = {
  slug: "gear-and-delivery",
  name: "Gear & Delivery",
  line: "Add-on equipment, dog life jackets, delivery and contactless return.",
  image: "https://images.unsplash.com/photo-1604087472033-cae0bd418fec?auto=format&fit=crop&w=2000&q=80",
};

// Illustrative stats shown on Home Waters cards.
// Live data is intentionally NOT fetched — TroutRoutes / NWS are linked instead.
export const HOME_WATERS = [
  {
    name: "Madison River",
    image: "https://images.unsplash.com/photo-1604087472033-cae0bd418fec?auto=format&fit=crop&w=1600&q=80",
    flow: "2,240 CFS",
    flowNote: "Above Normal",
    flowTrend: "up",
    weather: "57°F",
    weatherNote: "Sunny",
    weatherIcon: "sun",
    report: "Good",
    reportTone: "good",
    note: "Current flows and planning resources.",
    troutRoutes: "https://troutroutes.com/",
    nws: "https://www.weather.gov/",
  },
  {
    name: "Gallatin River",
    image: "https://images.unsplash.com/photo-1634829983497-05683868a580?auto=format&fit=crop&w=1600&q=80",
    flow: "1,420 CFS",
    flowNote: "Above Normal",
    flowTrend: "up",
    weather: "50°F",
    weatherNote: "Partly Cloudy",
    weatherIcon: "cloud-sun",
    report: "Good",
    reportTone: "good",
    note: "Current flows and planning resources.",
    troutRoutes: "https://troutroutes.com/",
    nws: "https://www.weather.gov/",
  },
  {
    name: "Yellowstone River",
    image: "https://images.pexels.com/photos/37736201/pexels-photo-37736201.jpeg?auto=compress&cs=tinysrgb&w=1600",
    flow: "6,280 CFS",
    flowNote: "Above Normal",
    flowTrend: "up",
    weather: "60°F",
    weatherNote: "Sunny",
    weatherIcon: "sun",
    report: "Good",
    reportTone: "good",
    note: "Current flows and planning resources.",
    troutRoutes: "https://troutroutes.com/",
    nws: "https://www.weather.gov/",
  },
  {
    name: "Missouri River",
    image: "https://images.unsplash.com/photo-1505852959938-8193566b2f8e?auto=format&fit=crop&w=1600&q=80",
    flow: "9,150 CFS",
    flowNote: "Above Normal",
    flowTrend: "up",
    weather: "62°F",
    weatherNote: "Sunny",
    weatherIcon: "sun",
    report: "Good",
    reportTone: "good",
    note: "Current flows and planning resources.",
    troutRoutes: "https://troutroutes.com/",
    nws: "https://www.weather.gov/",
  },
  {
    name: "Jefferson River",
    image: "https://images.unsplash.com/photo-1579539771986-d715a566e4fb?auto=format&fit=crop&w=1600&q=80",
    flow: "880 CFS",
    flowNote: "Normal",
    flowTrend: "level",
    weather: "55°F",
    weatherNote: "Partly Cloudy",
    weatherIcon: "cloud-sun",
    report: "Fair",
    reportTone: "fair",
    note: "Current flows and planning resources.",
    troutRoutes: "https://troutroutes.com/",
    nws: "https://www.weather.gov/",
  },
  {
    name: "Hebgen Lake & Quake Lake",
    image: "https://images.unsplash.com/photo-1671391511358-226c1799e054?auto=format&fit=crop&w=1600&q=80",
    flow: "N/A",
    flowNote: "Lake",
    flowTrend: "lake",
    weather: "68°F",
    weatherNote: "Breezy",
    weatherIcon: "wind",
    report: "Fair",
    reportTone: "fair",
    note: "Weather and planning resources.",
    troutRoutes: "https://troutroutes.com/",
    nws: "https://www.weather.gov/",
  },
];

export const PARTNERS_4_THE_WATER = [
  { name: "Jefferson River Watershed Council", short: "Jefferson River Watershed Council", url: "https://jeffersonriverwc.org/" },
  { name: "Joe Brooks TU", short: "Joe Brooks TU", url: "https://www.tu.org/" },
  { name: "Madison-Gallatin TU", short: "Madison-Gallatin TU", url: "https://www.tu.org/", note: "to confirm" },
  { name: "Missouri partner", short: "Missouri partner", url: "#", note: "to confirm" },
];

export const COMMUNITY_LINKS = [
  { name: "Montana Raft Frames", category: "Local river equipment / raft systems" },
  { name: "Big Sky Rod Boxes", category: "Local river equipment" },
  { name: "Keep Fish Wet", category: "Fish handling / conservation education" },
  { name: "Blue Ribbon Nets", category: "Local gear / landing nets" },
  { name: "TroutRoutes", category: "River planning / mapping" },
  { name: "FishCamp", category: "Drift boat education" },
  { name: "Wet Fly Swing", category: "Media / education — TBD" },
  { name: "WaterMaster", category: "Vessel partner / solo craft" },
  { name: "Bridger Outdoor Sports", category: "Guide referral / community connection" },
];

export const PLANNING_TOOLS = [
  {
    name: "TroutRoutes",
    purpose: "River access, maps, flows, and planning.",
    url: "https://troutroutes.com/",
  },
  {
    name: "National Weather Service",
    purpose: "Weather, wind, storm, and safety conditions.",
    url: "https://www.weather.gov/",
  },
  {
    name: "FishCamp",
    purpose: "Drift boat clinic and rowing education.",
    url: "https://fishcamp.com/",
  },
  {
    name: "Fly Shop",
    purpose: "Fishing reports and local angling conditions.",
    url: "#",
    note: "Partner to be confirmed",
  },
];

export const FAQ = [
  {
    q: "Are dogs allowed?",
    a: "Yes. Dogs are welcome when the vessel, setup, and river day make sense. Dog life jackets are available by request. Dogs must remain under the renter's control at all times. Final responsibility, damage, and liability language will be confirmed before booking.",
  },
  {
    q: "Can I wear cleats or studded wading boots in the vessels?",
    a: "No. Cleats, studs, and metal-soled footwear are not allowed in any Gateway Boat Co. vessel. Please wear soft-soled river shoes or non-studded wading boots. Studs and cleats can damage floors, tubes, frames, and interior surfaces.",
  },
  {
    q: "What should I bring?",
    a: "Personal layers, sun protection, water, food, and any fishing gear or personal items you need for the day. Final checklist will vary by vessel, season, and river conditions.",
  },
  {
    q: "What does GBC provide?",
    a: "The reserved vessel and the standard equipment assigned to that vessel. Final included-equipment lists will be shown by vessel before launch, including any requested add-ons, dog life jackets, delivery/setup items, or trailer options.",
  },
  {
    q: "How do pickup and return work?",
    a: "Rentals are built around a 24-hour rental window. Final pickup, return, delivery, contactless return, and trailer procedures will be confirmed during booking.",
  },
  {
    q: "Do I need rowing experience?",
    a: "Yes — appropriate rowing experience is required for drift boat use. The FishCamp drift boat clinic is required for Big Eddy 360 rentals.",
  },
  {
    q: "Where should I check weather, flows, and river conditions?",
    a: "Use the Planning Tools page for TroutRoutes, the National Weather Service, FishCamp, and the selected fly shop fishing report resource. Customers are responsible for checking current conditions before the day.",
  },
  {
    q: "Is shuttle information available?",
    a: "Shuttle information will be added once final partners or recommendations are confirmed. Until then, customers should plan transportation and vehicle logistics before booking.",
  },
  {
    q: "Can I rent a trailer with the WaterMaster Bruin?",
    a: "A trailer may be available by request and availability. Trailer-supported Bruin rentals are priced at $225 / 24 hours. Standard Bruin rentals are $175 / 24 hours.",
  },
  {
    q: "What is the rental window?",
    a: "Rental pricing is based on a 24-hour rental window unless otherwise stated. Final pickup and return timing will be confirmed at booking.",
  },
  {
    q: "Are vessels available for fishing and recreational floats?",
    a: "Yes. Gateway Boat Co. serves both anglers and recreational floaters. Vessel fit depends on the river, group size, conditions, and the kind of day planned.",
  },
  {
    q: "What does the 24-hour rental window mean?",
    a: "Rates are based on a 24-hour rental window, not a rushed same-day return. That means more time, more flexibility, and less hassle around pickup, setup, river logistics, and return. The goal is simple: make the day feel easier from start to finish.",
  },
];

export const CONSERVATION_COPY = {
  montanaDna:
    "Gateway Boat Co. is built around Montana waters, trusted local makers, community relationships, and conservation that stays close to home.",
  montanaDnaSecondary:
    "The vessels, tools, and gear behind the experience are chosen with purpose. Whenever possible, we work with Montana makers, Montana businesses, and partners who share our commitment to Montana waters. Our community relationships are local. Our conservation commitments stay tied to the home waters these days depend on.",
  fourTheWater:
    "A portion of every Gateway Boat Co. booking supports conservation connected to the home waters we operate on.",
  onePercent:
    "An additional one percent of every booking goes to 1% for the Planet. That commitment extends beyond any one river and keeps the business tied to a broader conservation standard.",
  communityIntro:
    "A few trusted people, tools, and organizations connected to better days on the water.",
  castingForRecoveryHeadline: "This one's personal.",
  castingForRecovery:
    "Gateway Boat Co. supports Casting for Recovery through direct giving to the Southwest Montana Chapter and complimentary rental days for CfR alumnae.",
};
